export default __webpack_public_path__ + "static/media/LandingScreen.605ae5ed.png";